import React, { useState, useEffect, Fragment } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import Host from "../../Components/Host";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import HelmetComponent from "../../Components/HelmetComponent";
import { useSelector } from "react-redux";
import { getMetaByCountry } from "../../metaConfig";

function AboutUs() {
  const { userId, userToken, userEmail, userName, isMember, isPaymentMethod, languageCode, countryCode } = useSelector(
    (state) => state.auth
  );
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  const [isMetaTitle, setMetaTitle] = useState("");
  useEffect(() => {
    const { title } = getMetaByCountry(countryCode);
    setMetaTitle(title);
  }, [countryCode]);

  return (
    <>
      <HelmetComponent title={"About Us"} metaTitle={isMetaTitle} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div
                className="static-container-card"
                style={{
                  textAlign: "left",
                  padding: "20px",
                  background: "#fcfcfc",
                  border: "1px solid #eee",
                  borderRadius: "7px",
                }}
              >
                <h1 style={{ padding: "20px 0px 20px 0px", fontWeight: 300, fontSize: "1.4rem" }}>{t("about_us")}</h1>

                <p>Welcome to {Host?.domainName2}.</p>
                <p>{Host?.domainName2} is an e-commerce store based in the UAE, operated by Online World FZ LLC.</p>
                <p>
                  We offer a wide range of products across categories such as electronics, fashion, beauty, lifestyle,
                  home essentials, accessories, and more. Our goal is to make online shopping simple, secure, and
                  convenient by giving customers competitive prices, reliable delivery, and helpful customer support.
                </p>
                <p>
                  At {Host?.domainName2}, we believe shopping should feel smooth, clear, and dependable from the first
                  click to the final delivery. We work to ensure that product information, pricing, availability,
                  delivery timelines, and customer support are easy to understand, so customers can shop with
                  confidence.
                </p>
                <p>
                  We also provide secure payment options and delivery services through trusted logistics partners,
                  helping us deliver a shopping experience that truly rocks.
                </p>

                <h4>Customer Support</h4>
                <p>We believe customer support should be clear, responsive, and handled with care.</p>
                <p>
                  Our customer service team is available seven days a week from 8:00 AM to 10:00 PM UAE Time to assist
                  with orders, delivery updates, payment queries, returns, refunds, warranty support, and general
                  questions.
                </p>
                <p>You can contact us by email or phone:</p>
                <p>
                  Email: {Host?.email}
                  <br />
                  Phone: {Host?.phone}
                </p>

                <h4>Our Mission</h4>
                <p>
                  Our mission is simple: to help customers find the products they are looking for at competitive prices,
                  deliver them as swiftly as possible, and provide support throughout the shopping experience.
                </p>
                <p>
                  We aim to make every order clear, secure, and convenient from checkout to delivery, giving customers
                  an online shopping experience that rocks for all the right reasons.
                </p>

                <h4>Business Information</h4>
                <div style={{ fontSize: "14px" }}>
                  <strong>Trade Name: {Host?.domainName2}</strong><br />
                  <strong>Trade License: {Host?.companyName}</strong>
                  <br />
                  <strong>License Number: {Host?.licenseNumber}</strong>
                </div>
                <p style={{ lineHeight: 2 }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: Host?.address,
                    }}
                  ></div>
                  <MailOutlineIcon style={{ fontSize: "18px" }} /> {Host?.email} <br />
                  <PhoneIcon style={{ fontSize: "18px" }} /> {Host?.phone}
                </p>
                <p>Customer Support: {Host?.customerSupport}</p>
                <p>Website: {window.location.hostname}</p>

                <p>&nbsp;</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
